module.exports = __webpack_public_path__ + "img/lace-accent.79493872.svg";